import {OldVideos} from "#/src/pages/videos/OldVideos";
import {PromotedVideos} from "#/src/pages/videos/PromotedVideos";
import {LatestVideos} from "#/src/pages/videos/LatestVideos";
import {ApiVideo} from "#/src/definitions/ApiDefinitions";
import {Sort} from "#/src/utils/sort-utils";
import React from "react";
import {VideoCard} from "#/src/components/VideoCard";
import {LoaderSvg} from "#/src/components/LoaderSvg";
import {AwaitingContent} from "#/src/pages/videos/AwaitingContent";

interface Props {
  category: "MAIN" | "AWAITING",
  query: {
    enabled: boolean,
    isPending: boolean,
    error: boolean,
    queriedData: ApiVideo[] | null
  }
}

export function Content({category, query}: Props) {
  function renderQueriedVideos() {
    if (query.isPending) {
      return <div className={"col-12 text-center text-white"}><LoaderSvg/> Ładuję zawartość...</div>
    }
    if (query.error) {
      return <div className={"col-12 text-center text-danger"}>Nie udało się załadować...</div>
    }
    const queriedData = Sort.byDate(query.queriedData!);
    if (queriedData.length == 0) {
      return <div className={"col-12 text-center text-white"}>Brak zawartości</div>
    }
    return queriedData.map((video: ApiVideo) => {
      return <div key={video.id} className="col-xl-3 col-sm-6 col-md-4"><VideoCard video={video}/></div>
    });
  }

  if (query.enabled) {
    return <section className="front-header mt-9">
      <div className="container-xxl">
        <div className={"row"}>
          {renderQueriedVideos()}
        </div>
      </div>
    </section>
  }
  if(category == "AWAITING") {
    return <AwaitingContent/>
  }
  return <main>
    <LatestVideos/>
    <PromotedVideos/>
    <OldVideos/>
  </main>
}